import * as React from 'react';
import * as moment from 'moment';
import * as cn from 'classnames';

import './Request.less';
import { Separator } from '@ui/components';
import { Icon } from 'antd';

interface Props {
  request: any;
  reload: (request: any) => void;
}

const MapStatusIcons = {
  success: (
    <Icon type="arrow-right" style={{ color: '#00cb07', fontWeight: 'bold' }} />
  ),
  fail: <Icon type="reload" style={{ color: '#d90000', fontWeight: 'bold' }} />,
};

class Request extends React.PureComponent<Props> {
  state = {
    showMeta: false,
  };

  setShowMeta = (showMeta: boolean) => {
    this.setState({ showMeta });
  };

  render() {
    const { request, reload } = this.props;

    const { showMeta } = this.state;

    const isFail = request.status === 'fail';

    const style = cn('request-card__status', {
      'request-card__status--fail': isFail,
    });

    return (
      <div className="request-card">
        <div className="request-card__desc">
          <div
            className={style}
            onClick={
              isFail && request.user ? () => reload(request) : () => null
            }
          >
            {MapStatusIcons[request.status]}
          </div>
          <div className="request-card__id">#{request.id}</div>
          <div className="request-card__store">{request.store.name}</div>
          <div className="request-card__user">
            {request.user ? request.user.login : 'менеджер удален'}
          </div>
          <div className="request-card__date">
            {moment(request.updated).format('DD.MM.YYYY')}
          </div>
          <div>
            {!showMeta ? (
              <Icon type="caret-down" onClick={() => this.setShowMeta(true)} />
            ) : (
              <Icon type="caret-up" onClick={() => this.setShowMeta(false)} />
            )}
          </div>
        </div>
        {showMeta && (
          <div className="request-card__meta">
            <div className="request-card__region">
              <span>{request.store.city.region.name} Область</span>
              <span>{request.store.city.name}</span>
            </div>
            <Separator height="auto" />
            <div className="request-card__collections">
              {request.collections.map((collection: any) => (
                <span>{collection.name}; </span>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Request;



// WEBPACK FOOTER //
// ./src/scenes/Requests/components/Request/Request.tsx